<template>
    <div class="ibox float-e-margins">
        <div class="ibox-title">
            <h5>Editor de Artigo</h5>
        </div>
        <div class="ibox-content no-padding">
            <form class="m-l m-r">
                <input type="hidden" name="_method" value="patch"/>
                <div class="row m-t">
                    <div class="col-md-6">
                        <div class="form-group"
                            :class="{ 'has-error': form.errors.has('title') }"
                        >
                            <label for="title" class="control-label">Titulo</label>
                            <input type="text"
                                class="form-control"
                                v-model="form.title"
                                @blur="slugifyTitle"
                            >
                            <span class="help-block" v-if="form.errors.has('title')">
                                {{ form.errors.first('title') }}
                            </span>
                        </div>
                        <div class="form-group"
                            :class="{ 'has-error': form.errors.has('slug') }"
                        >
                            <label for="slug" class="control-label">Url</label>
                            <input placeholder="Usar-hífen-em-vez-de-espaços"
                                type="text"
                                class="form-control"
                                v-model="form.slug"
                            >
                            <span class="help-block" v-if="form.errors.has('slug')">
                                {{ form.errors.first('slug') }}
                            </span>
                        </div>
                        <div class="form-group">
                            <label>Tags</label>
                            <input-tag :on-change="addTag" :tags="form.tags"></input-tag>
                        </div>
                        <div class="form-group">
                            <label>Descrição</label>
                            <input type="text"
                                class="form-control"
                                v-model="form.description"
                            >
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="image">Imagem:</label>
                            <div class="upload-thumb-image">
                                <img width="100%" :src="imagePreview" :alt="form.slug">
                            </div>
                            <input type="file"
                                class="thumb-artcile-image-input"
                                name="image"
                                @change="previewThumb"
                            >
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="m-b">
                            <quill-editor v-model="form.body"
                                        :options="editorOptions"
                            ></quill-editor>
                            <span class="help-block" v-if="form.errors.has('body')">
                                {{ form.errors.first('body') }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="row m-b">
                    <div class="col-md-offset-2 col-md-3">
                        <button class="btn btn-lg btn-clear btn-block"
                                v-if="!isNew"
                                @click.prevent="onDelete">
                            Excluir
                        </button>
                    </div>
                    <div class="col-md-offset-2 col-md-3">
                        <button class="btn btn-lg btn-primary btn-block"
                                @click.prevent="onSubmit"
                        >
                            Salvar
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import slugify from 'slugify';
import InputTag from 'vue-input-tag';
import Form from 'form-backend-validation';
import { quillEditor } from 'vue-quill-editor';

export default {
    props: {
        article: {
            type: Object,
            default() {
                return {
                    title: null,
                    image: null,
                    slug: null,
                    tags: [],
                    description: null,
                    body: null,
                };
            },
        },
        method: {
            type: String,
        },
        action: {
            type: String,
        },
    },
    components: {
        InputTag,
        quillEditor,
    },
    data() {
        return {
            form: new Form({
                ...this.article,
                imageUpload: null,
                _method:'PATCH',
            }),
            editorOptions: {
                placeholder: 'Texto do seu artigo',
            },
            imageToPreview:null
        };
    },
    computed: {
        imagePreview() {
            return this.imageToPreview || this.form.image;
        },
        isNew() {
            return this.method === 'post';
        },
    },
    methods: {
        addTag(tags) {
            this.form.tags = tags;
        },
        onSubmit() {
            this.form['post'](this.action)
                .then(() => {
                    toastr.success('Artigo salvo com sucesso');
                    location.href = '/admin/articles';
                })
                .catch((error) => {
                    toastr.error('Erro ao publicar artigo');
                });
        },
        onDelete() {
            axios.delete(this.action)
                .then(() => {
                    toastr.success('Artigo excluido com sucesso');
                    location.href = '/admin/articles';
                })
                .catch((error) => {
                    toastr.error('Erro ao excluir artigo');
                });
        },
        slugifyTitle() {
            const { title, slug } = this.form;

            if (!slug && title) {
                this.form.slug = slugify(title).toLowerCase();
            }
        },
        previewThumb(event) {
            const input = event.target;

            if (input.files && input.files[0]) {
                const reader = new FileReader();

                reader.onload = (e) => {
                    this.imageToPreview = e.target.result;
                    this.form.imageUpload = input.files[0];
                };

                reader.readAsDataURL(input.files[0]);
            }
        },
    },
}
</script>

<style lang="scss">
    .vue-input-tag-wrapper {
        padding: 1px !important;
        display: flex;
        flex-wrap: wrap;
        border: 1px solid #e5e6e7 !important;
        min-height: 34px !important;
    }

    .vue-input-tag-wrapper .input-tag {
        background-color: #0196f9 !important;
        color: #fff !important;
        border-color: darken(#0196f9, 30%) !important;
        padding: 5px !important;
        margin-bottom: 0 !important;
    }

    .vue-input-tag-wrapper .input-tag .remove {
        color: #fff !important;
    }

    .vue-input-tag-wrapper .new-tag {
        margin: 0 !important;
        padding: 3px !important;
        font-size: 14px !important;
        flex-grow: 1;
    }
</style>
